import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { siteConfig } from "../config/siteConfig";
import BookingModal from "./BookingModal";

const navLinks = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Rooms", href: "#rooms" },
  // { label: "Restaurant & Bar", href: "#restaurant-bar" },
  { label: "Nearby", href: "#nearby" },
  { label: "Gallery", href: "#gallery" },
  // { label: "Offers", href: "#offers" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [bookingOpen, setBookingOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <header
        data-testid="navbar"
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          scrolled
            ? "bg-[#FAF9F6]/95 backdrop-blur-md shadow-sm py-3"
            : "bg-transparent py-5"
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between">
          <a
            href="#home"
            className="flex items-center gap-3"
            data-testid="navbar-logo"
          >
            <img
              src={siteConfig.hotel.logoUrl}
              alt="Thuruliya Logo"
              className={`object-contain transition-all duration-500 ${
                scrolled ? "h-10 w-10" : "h-12 w-12"
              }`}
            />
            <div className="hidden sm:flex flex-col leading-tight">
              <span
                className={`font-display text-lg tracking-wide ${
                  scrolled ? "text-[#1A362D]" : "text-[#FAF9F6]"
                }`}
              >
                {siteConfig.hotel.name}
              </span>
              <span
                className={`text-[10px] tracking-[0.3em] uppercase ${
                  scrolled ? "text-[#C5A059]" : "text-[#C5A059]"
                }`}
              >
                {siteConfig.hotel.location}
              </span>
            </div>
          </a>

          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-${l.label.toLowerCase()}-link`}
                className={`text-xs uppercase tracking-[0.22em] hover:text-[#C5A059] transition-colors ${
                  scrolled ? "text-[#2C2C2C]" : "text-[#FAF9F6]"
                }`}
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <button
              onClick={() => setBookingOpen(true)}
              className={`hidden md:inline-flex btn-primary !py-2.5 !px-5 !text-[11px]`}
              data-testid="navbar-book-now-btn"
            >
              Book Now
            </button>
            <button
              className="lg:hidden p-2"
              onClick={() => setOpen(!open)}
              data-testid="navbar-mobile-toggle"
              aria-label="Toggle menu"
            >
              {open ? (
                <X className={scrolled ? "text-[#1A362D]" : "text-[#FAF9F6]"} />
              ) : (
                <Menu
                  className={scrolled ? "text-[#1A362D]" : "text-[#FAF9F6]"}
                />
              )}
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        {open && (
          <div
            data-testid="mobile-menu"
            className="lg:hidden bg-[#FAF9F6] border-t border-[#EBE5D9] px-6 py-6"
          >
            <nav className="flex flex-col gap-4">
              {navLinks.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="text-sm uppercase tracking-[0.22em] text-[#2C2C2C] hover:text-[#C5A059]"
                  data-testid={`mobile-nav-${l.label.toLowerCase()}-link`}
                >
                  {l.label}
                </a>
              ))}
              <button
                onClick={() => {
                  setOpen(false);
                  setBookingOpen(true);
                }}
                className="btn-primary mt-2"
                data-testid="mobile-book-now-btn"
              >
                Book Now
              </button>
            </nav>
          </div>
        )}
      </header>

      <BookingModal open={bookingOpen} onOpenChange={setBookingOpen} />
    </>
  );
}
